import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
  RecoilRoot,
} from 'recoil';
import auth from '../../utils/auth';
import PrivateRoute from '../components/privateRoute';
import Login from '../pages/login';
import NotFound from '../pages/notFound';
import TestComponent from '../pages/testComponent';
import PrivateNavigation from './privateNavigation';

class Navigation extends React.Component {
  render() {
    const { authenticated } = this.props;
    return (
      <main>
        <RecoilRoot>
          <Router>
            <Switch>
              <Route path="test-component" name="test-component" component={TestComponent} />
              <Route path="/login" name="login" component={Login} />
              <PrivateRoute path="/" name="full" component={PrivateNavigation} authenticated={authenticated || auth.isSuccess()} />
              <Route path="*" name="notFound" component={NotFound} />
            </Switch>
          </Router>
        </RecoilRoot>
      </main>
    );
  }
}

Navigation.defaultProps = {
  authenticated: false,
};

Navigation.propTypes = {
  authenticated: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    authenticated: state.login.isSuccess,
  };
}
export default connect(mapStateToProps)(Navigation);
